import React, { Fragment } from "react";

import img13 from "../../../images/service/Binance Smart Chain Development/1.png";
import img14 from "../../../images/service/Binance Smart Chain Development/2.png";

import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import Benefit from "../../../components/PageSection/BenefitSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";


// ------------------------------------
// DATA
// ------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "BSC dApp Development",
    content:
      "Design and development of scalable decentralized applications optimized for performance on Binance Smart Chain.",
  },
  {
    icon: sIcon2,
    title: "Smart Contract Development",
    content:
      "Secure, gas-efficient Solidity smart contracts with thorough testing and auditing.",
  },
  {
    icon: sIcon3,
    title: "DeFi Protocol Development",
    content:
      "Development of decentralized exchanges, staking platforms, yield farming, and lending protocols.",
  },
];

const benefits = [
  {
    title: "High Scalability",
    description:
      "Binance Smart Chain delivers fast block times and high throughput for large-scale decentralized applications.",
    icon: sIcon1,
  },
  {
    title: "Low Transaction Costs",
    description:
      "Extremely low gas fees make BSC ideal for cost-sensitive Web3 and DeFi platforms.",
    icon: sIcon2,
  },
  {
    title: "EVM Compatibility",
    description:
      "Seamlessly migrate Ethereum-based dApps and smart contracts to Binance Smart Chain.",
    icon: sIcon3,
  },
  {
    title: "Cross-Chain Interoperability",
    description:
      "Dual-chain architecture enables smooth asset transfers across blockchain networks.",
    icon: sIcon4,
  },
  {
    title: "Enterprise-Grade Security",
    description:
      "Validator-based security model ensures reliability, censorship resistance, and trust.",
    icon: sIcon5,
  },
  {
    title: "Rapid Ecosystem Growth",
    description:
      "Strong tooling, documentation, and adoption accelerate go-to-market timelines.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is Binance Smart Chain?",
    a: "Binance Smart Chain is a blockchain network that supports smart contracts and decentralized applications with low fees and high throughput.",
  },
  {
    q: "Is Binance Smart Chain compatible with Ethereum?",
    a: "Yes. BSC is fully EVM-compatible, allowing Ethereum tools and smart contracts to work seamlessly.",
  },
  {
    q: "What can be built on Binance Smart Chain?",
    a: "DeFi platforms, NFT marketplaces, gaming dApps, DAOs, wallets, and enterprise blockchain solutions.",
  },
  {
    q: "Do you provide smart contract audits?",
    a: "Yes. We offer comprehensive testing, optimization, and auditing services for BSC smart contracts.",
  },
];

// ------------------------------------
// PAGE COMPONENT
// ------------------------------------

export default function BinanceSmartChainServices() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Binance Smart Chain Development"
        pagesub="Build scalable and cost-efficient Web3 solutions"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Build Powerful Web3 Products on{" "}
            <span className="gradient-text">Binance Smart Chain</span>
          </>
        }
        subtitle={`Binance Smart Chain enables fast, low-cost, and secure decentralized applications.
We help businesses design, develop, and deploy scalable BSC-based dApps, DeFi platforms, and smart contracts.`}
        buttonText="Consult BSC Experts"
        buttonLink="/contact"
        image={img13}
        imageAlt="Binance Smart Chain Development"
      />
      
      <TheorySection
  title="Understanding the Evolution of NFTs"
  image={img14}
  paragraphs={[
    "Binance Smart Chain (BSC) is a high-performance blockchain networkengineered to support decentralized applications, digital assets, andfinancial protocols at scale. With native support for smart contracts and seamless Ethereum compatibility, BSC empowers developers to build advanced Web3 products without the limitations of high transaction costs or network congestion.",
    "Leveraging a Proof of Staked Authority (PoSA) consensus mechanism,Binance Smart Chain achieves an optimal balance between decentralization,speed, and security. This makes BSC an ideal foundation for DeFiecosystems, NFT platforms, Web3 marketplaces, and enterprise-gradeblockchain solutions that demand reliability and performance.",]}
/>

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our Binance Smart Chain Development Services"
        cards={serviceCards}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit
        title="Benefits of Binance Smart Chain Development"
        benefits={benefits}
      />



      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of Binance Smart Chain"
        subtitle="A robust blockchain infrastructure built for speed, scalability, and interoperability."
        features={[
          {
            icon: sIcon1,
            title: "Proof of Staked Authority",
            description:
              "Combines staking and authority models for faster block validation.",
          },
          {
            icon: sIcon2,
            title: "Cross-Chain Compatibility",
            description:
              "Supports seamless asset transfers across blockchain ecosystems.",
          },
          {
            icon: sIcon3,
            title: "EVM Compatibility",
            description:
              "Run Ethereum smart contracts and tools without modifications.",
          },
          {
            icon: sIcon4,
            title: "BEP-20 Token Standard",
            description:
              "Create efficient and scalable digital assets for various use cases.",
          },
          {
            icon: sIcon5,
            title: "Advanced Security",
            description:
              "Validator-based security ensures transaction integrity and trust.",
          },
          {
            icon: sIcon6,
            title: "Dynamic Governance",
            description:
              "Community-driven governance fosters transparency and decentralization.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Deep Expertise in Binance Smart Chain",
          "Secure & Audited Smart Contracts",
          "End-to-End Web3 Development",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
